const mediaItems = [
  {
    title: '2026年7月国产片单精选',
    desc: '本月最受关注的91国产免费视频剧集与短片汇总，从剧情到喜剧全覆盖。',
    duration: '15部合集',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20abstract%20design%20with%20warm%20coral%20red%20and%20gold%20gradients%2C%20film%20clapperboard%20motif%20subtle%2C%20dramatic%20lighting%2C%20dark%20rich%20background%2C%20monthly%20selection%20theme%2C%20no%20people%20no%20text%2C%20elegant%20editorial%20film%20festival%20aesthetic&width=800&height=500&seq=media-july-2026&orientation=landscape',
  },
  {
    title: '91传媒视频在线最新力作',
    desc: '传媒团队倾力打造的高品质系列短片，91传媒视频在线品质保证。',
    duration: '8部精选',
    img: 'https://readdy.ai/api/search-image?query=A%20professional%20cinematic%20abstract%20composition%20with%20warm%20amber%20and%20deep%20red%20tones%2C%20production%20studio%20vibe%2C%20soft%20spotlight%20effect%2C%20dark%20atmospheric%20background%2C%20high%20quality%20film%20production%20aesthetic%2C%20no%20people%20no%20text%2C%20luxurious%20movie%20set%20feel&width=800&height=500&seq=media-prod-2026&orientation=landscape',
  },
  {
    title: '国产高清不缓冲体验升级',
    desc: '全站播放技术全面升级，91国产视频在线观看更流畅，画质更清晰。',
    duration: '技术升级',
    img: 'https://readdy.ai/api/search-image?query=A%20sleek%20modern%20abstract%20tech-inspired%20design%20with%20warm%20copper%20and%20soft%20gold%20gradients%2C%20digital%20wave%20patterns%20subtle%2C%20high%20speed%20data%20flow%20concept%2C%20dark%20background%2C%20streaming%20technology%20theme%2C%20no%20people%20no%20text%2C%20clean%20futuristic%20aesthetic&width=800&height=500&seq=media-tech-2026&orientation=landscape',
  },
  {
    title: '周末观影指南：编辑推荐',
    desc: '每周末编辑团队精选5部不容错过的国产免费视频，陪你度过悠闲时光。',
    duration: '5部推荐',
    img: 'https://readdy.ai/api/search-image?query=A%20cozy%20warm%20cinematic%20abstract%20design%20with%20soft%20golden%20and%20rose%20gradients%2C%20weekend%20relaxation%20vibe%2C%20subtle%20popcorn%20and%20film%20elements%2C%20dark%20rich%20background%2C%20home%20theater%20atmosphere%2C%20no%20people%20no%20text%2C%20inviting%20editorial%20style&width=800&height=500&seq=media-weekend-2026&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
            媒体资讯
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-[560px] mx-auto">
            了解91免费视频网站的最新动态、内容更新与观影推荐
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="rounded-xl overflow-hidden bg-background-50 border border-background-200/60 transition-all duration-200 hover:-translate-y-0.5"
            >
              <div className="relative h-[180px] md:h-[200px] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <span className="absolute bottom-3 left-3 px-2 py-0.5 rounded bg-background-950/60 text-background-200 text-xs whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}